<template>
   <div>
     <section class="panel panel-default">
      <header v-if="DataTable.Configurazione.Titolo" class="panel-heading">
        {{DataTable.Configurazione.Titolo}}
      </header>
      <div class="row wrapper" v-if="DataTable.EditRicercaVisibile || DataTable.TastoAggiungiVisibile">
         <div class="col-sm-5 m-b-xs" v-if="!TastoDisabilitato && DataTable.TastoAggiungiVisibile" >
             <button class="btn btn-sm btn-success" style="float:left;" @click="AggiungiRighe();">Aggiungi</button>
             <div style="float:left">
                <input type="number" min="1" style="width: 60px; height: 30px" v-model="NrRigheDaAggiungere">
             </div>
        </div>
        <div class="col-sm-5 m-b-xs" v-else>
        </div>
        <div class="col-sm-4 m-b-xs">
        </div>
        <div class="col-sm-3" v-if="DataTable.EditRicercaVisibile">
            <input type="text" class="input-sm form-control" placeholder="Cerca..." v-model="Filtro">
        </div>
      </div>
      <!-- Tabella standard-->
      <div v-if="RowType == undefined" class="table-responsive" :style="{'overflow-x' : 'auto', 'overflow-y' : 'auto' , 'max-height' : (AltezzaTabella == undefined ? '100%' : AltezzaTabella)}">
        <table class="table table-striped b-t b-light" :style="{ width : (DataTable.Configurazione.Larghezza == undefined ? '100%' : DataTable.Configurazione.Larghezza) }">
          <thead style="position: sticky; top: 0">
            <tr>
              <template v-for="Colonna in DataTable.Configurazione.Colonne" :key="Colonna.Id" 
                                                                            :class="{ 'th-sortable' : Colonna.Ordinamento }">
                             
                <th v-if="!Colonna.Nascosta"    :style="{ width : Colonna.Larghezza,
                                                          'text-align' : Colonna.GetTitleAlignment() }" >
                  <!--{{ Colonna.Larghezza }}--> 
                    <template v-if="Colonna.ShowTitle">  
                      {{Colonna.Titolo + (Colonna.Ordinamento ? "&nbsp;&nbsp;" : "")}}
                      <span v-if="Colonna.Ordinamento" class="th-sort" @click="OnClickOrdinamento(Colonna)">
                        <i v-if="DataTable.OrdinatoPer.Campo == Colonna.Campo" 
                          class="fa" 
                          :class="{ 'fa-sort-up'   : DataTable.OrdinatoPer.Discendente,
                                    'fa-sort-down' : !DataTable.OrdinatoPer.Discendente  
                                  }"
                          style="box-sizing: border-box;">
                        </i>
                        <i class="fa fa-sort" style="box-sizing: border-box;"></i>
                      </span>
                    </template>
                </th>
              </template>
              <th :style="{ width : LarghezzaColonneRestanti}"></th>
              <th :style="{ width : LarghezzaColonneRestanti}" v-if="DataTable.DatiEliminabili"></th>
            </tr>
          </thead>
          <tbody>
             <template v-for="(Riga,NdxRiga) in RighePagina" :key="Riga.Dati[DataTable.Configurazione.CampoChiave]">
                <tr :class="{DivRighePari : NdxRiga % 2 == 0, DivRigheDispari : NdxRiga % 2 != 0}" :style="{ height : DataTable.Configurazione.AltezzaTutteLeRighe }">
                   <VUEDataRow :Riga="Riga" :DataTable="DataTable" @onClick="EventoOnClick" @onGetInfoAllegati="OnGetInfoAllegati" />
                </tr>
                <tr v-if="Riga.RowErrors().length != 0" :class="{DivRighePari : NdxRiga % 2 == 0, DivRigheDispari : NdxRiga % 2 != 0}">
                   <td :colspan="DataTable.Configurazione.Colonne.length + 2">
                     <label v-for="(Error,NdxError) in Riga.RowErrors()" :Key="NdxError" style="margin-bottom: 0px; margin-top:0px;" class="ZMFormLabelError">{{Error}}</label>
                   </td>
                </tr>
             </template>   
          </tbody>
        </table>
      </div>
      
      <footer class="panel-footer">
        <div class="row">
          <div class="col-sm-4 hidden-xs">
          </div>
          <div class="col-sm-3 text-center">
            <small class="text-muted inline m-t-sm m-b-sm">
               {{TestoPaginazione}}
            </small>
          </div>
          <div class="col-sm-5 text-right text-center-xs">                
            <ul class="pagination pagination-sm m-t-none m-b-none">
                  <li><a @click="OnClickFirstPage()"><i class="fa fa-backward"></i></a></li>
                  <li><a @click="PortaIndietroGruppoPagine()" ><i :class="{ ZMDisabled : !BackGruppoPagineVisibile }" class="fa fa-chevron-left"></i></a></li>
                  <li :class="{ active : IsActivePage(0)}"><a @click="OnClickChangePage(0)">{{Paginazione.StartGruppoPagine}}</a></li>
                  <li v-if="TastoPaginaVisibile(1)" :class="{ active : IsActivePage(1)}"><a @click="OnClickChangePage(1)">{{Paginazione.StartGruppoPagine + 1}}</a></li>
                  <li v-if="TastoPaginaVisibile(2)" :class="{ active : IsActivePage(2)}"><a @click="OnClickChangePage(2)">{{Paginazione.StartGruppoPagine + 2}}</a></li>
                  <li v-if="TastoPaginaVisibile(3)" :class="{ active : IsActivePage(3)}"><a @click="OnClickChangePage(3)">{{Paginazione.StartGruppoPagine + 3}}</a></li>
                  <li v-if="TastoPaginaVisibile(4)" :class="{ active : IsActivePage(4)}"><a @click="OnClickChangePage(4)">{{Paginazione.StartGruppoPagine + 4}}</a></li>
                  <li><a @click="PortaAvantiGruppoPagine()"><i :class="{ ZMDisabled : !ForwardGruppoPagineVisibile }" class="fa fa-chevron-right"></i></a></li>
                  <li><a @click="OnClickLastPage()"><i class="fa fa-forward"></i></a></li>
            </ul>
          </div>
        </div>
      </footer>
    </section>
   </div>
</template>

<script>
//****************************************
//OBSOLETO
//NON PORTARE AVANTI QUESTA LIBRERIA. PASSARE ALLA VERSIONE 2
//***********************************************************
//Versione 1.5.3 - 29 Gennaio 2026 - Nicole Acciai
//                 - FIX: rimosso table-layout: fixed da Tabella standard
//Versione 1.5.2 - 29 Gennaio 2026 - Nicole Acciai
//                 - FIX: Risolto il problema delle percentuali delle colonne 
//Versione 1.5.1 - 23 Gennaio 2026 - Nicole Acciai, Federico Migliazzi
//                 - NEW: Aggiunti Allegati
//                 - NEW: Aggiunti Memo
//                 - NEW: Gestione colonne nascoste
//Versione 1.4.1 - 19 Febbraio 2025 - Federico Migliazzi
//                 - NEW: Aggiunti tasti per andare in fondo ed in cima alla tabella e altre modifiche grafiche
//Versione 1.3.1  11 febbraio 2025 - Simone Biancolilla
//                 - NEW: Aggiunto la possibilità di specificare il numero di righe che deve avere la tabella
//Versione 1.2.1  19 Settembre 2023 - Francesco Ardini
//                 - NEW: Rimosso il CSS dal file
//Versione 1.1.1  19 Settembre 2023 - Francesco Ardini
//                 - NEW: Gestiti i DatiEliminabili
//Versione 1.0.1  03 Agosto 2023 - Francesco Ardini
//                 - FIX: Rimosso il name
//Versione 1.0.0  03 Agosto 2023 - Francesco Ardini
//                 - Prima Versione
import VUEDataRow from './/VUEDataRow.vue'

export default 
{
    emits: ['onChange','onClick', 'onGetInfoAllegati'],
    data() 
    {
        return {
             Paginazione : {
                               NrRighe           : 0,
                               NrPagina          : 1,
                               StartGruppoPagine : 1
                           },
             NrRigheDaAggiungere : 1,
             Filtro              : '',
             OrdinamentoInCorso  : false,
        };
    },
    props: ["DataTable","RowType","TastoDisabilitato", "NumeroRighe","AltezzaTabella"],
    watch:
    {
      DataTable :
      {
         handler()
         {
           this.DataTable.CheckDoppioni();
           this.$emit('onChange');
         },
         deep : true
      }
    },
    methods: 
    {
      AggiungiRighe()
      {
         this.DataTable.AddRowsOnTop(this.NrRigheDaAggiungere);
      },
      TastoPaginaVisibile(Offset)
      {
        return (this.Paginazione.StartGruppoPagine + Offset - 1) * this.Paginazione.NrRighe < this.RigheFiltrate.length
      },
      OnClickOrdinamento(Colonna)
      {
        var OrdinamentoDiscendente = false;
        if(Colonna.Campo == this.DataTable.OrdinatoPer.Campo)
           OrdinamentoDiscendente = !this.DataTable.OrdinatoPer.Discendente;
        this.DataTable.OrdinaPer(Colonna.Campo,OrdinamentoDiscendente);
      },
      IsActivePage(Offset)
      {
        return this.Paginazione.NrPagina == this.Paginazione.StartGruppoPagine + Offset;
      },
      OnClickChangePage(Offset)
      {
        this.Paginazione.NrPagina = this.Paginazione.StartGruppoPagine + Offset;
      },
      OnClickFirstPage()
      {
        this.Paginazione.NrPagina = 1
        this.Paginazione.StartGruppoPagine = 1;
      },
      OnClickLastPage()
      { 
        this.Paginazione.NrPagina = Math.ceil(this.RigheFiltrate.length / this.Paginazione.NrRighe)
        if(!isNaN(this.Paginazione.NrPagina) == true)
        {
          if(this.Paginazione.NrPagina >= 5)
            this.Paginazione.StartGruppoPagine = this.Paginazione.NrPagina - 4;
          else this.Paginazione.StartGruppoPagine = 1;
        }
      }, 
      PortaIndietroGruppoPagine()
      {
          if(this.BackGruppoPagineVisibile)
             if(--this.Paginazione.NrPagina < this.Paginazione.StartGruppoPagine)
                this.Paginazione.StartGruppoPagine--;
      },
      PortaAvantiGruppoPagine()
      {
        if(this.Paginazione.NrPagina+1 <= Math.ceil(this.RigheFiltrate.length / this.Paginazione.NrRighe))
          if(this.ForwardGruppoPagineVisibile)
              if(++this.Paginazione.NrPagina > this.Paginazione.StartGruppoPagine + 4)
                  this.Paginazione.StartGruppoPagine++;
      },
      EventoOnClick(Riga,Colonna)
      {
        this.$emit('onClick',Riga,Colonna)  
      },
      OnGetInfoAllegati(Parametri)
      {
        this.$emit("onGetInfoAllegati", Parametri);
      },
    },
    components: 
    { 
      VUEDataRow
    },
    computed:
    {
      RigheFiltrate :
      {
        get()
        {
          var Self = this;
          var Filtro = this.Filtro.toUpperCase().trim();
          var ListaRighe = this.DataTable.Righe.filter(function(Riga)
          {
            if(Riga.Eliminato)
               return false;
            if(Filtro == '') 
               return true;
            for(let i = 0; i < Self.DataTable.Configurazione.Colonne.length;i++)
            {
                let Colonna = Self.DataTable.Configurazione.Colonne[i];
                if(Riga.GetText(Colonna.Campo).toUpperCase().indexOf(Filtro) !== -1)
                   return true;
            }
            return false;
          });
          
          return ListaRighe;
        }
      },
      RighePagina :
      {
        get()
        {
          let Result = [];
          for(let i = (this.Paginazione.NrPagina - 1) * this.Paginazione.NrRighe;
              i < this.RigheFiltrate.length && i < (this.Paginazione.NrPagina) * this.Paginazione.NrRighe;
              i++)
              Result.push(this.RigheFiltrate[i]);
          return Result;
        }
      },
      ForwardGruppoPagineVisibile : 
      {
        get()
        {
          return this.RigheFiltrate.length > this.Paginazione.NrPagina * this.Paginazione.NrRighe;
        }
      },
      LarghezzaColonneRestanti :
      {
          get()
          {
            var Larghezza = 0;
            if(this.DataTable.LarghezzaColonneRestantiInPixels == 0)  
            {
              this.DataTable.Configurazione.Colonne.forEach(function(AColonna)
              {
                Larghezza += parseInt(AColonna.Larghezza);
              })
              return parseFloat((100 - Larghezza) / 2,2)  + '%';
            }
            else return this.DataTable.LarghezzaColonneRestantiInPixels + 'px';
          }
      },
      BackGruppoPagineVisibile :
      {
        get()
        {
             return this.Paginazione.NrPagina > 1;
        }
      },
      TestoPaginazione :
      {
        get()
        {
          var MaxRighe = this.Paginazione.NrRighe * (this.Paginazione.NrPagina);
          if(this.RigheFiltrate.length < MaxRighe) MaxRighe = this.RigheFiltrate.length;
          let StartRecord = this.RigheFiltrate.length == 0 ? 0 : this.Paginazione.NrRighe * (this.Paginazione.NrPagina - 1) + 1;
          return "Visualizzati " +  StartRecord + ' - ' +
                  MaxRighe + ' di ' +  this.RigheFiltrate.length + ' risultati'
        }
      },
      ComputedNumeroRighe:
      {
        get()
        {
          let NumeroRighe                              = parseInt(this.NumeroRighe);
          let VALORE_FUNZIONE_SIGN_PER_NUMERO_NEGATIVO = -1;
          let NUMERO_DEFAULT_RIGHE                     = 40;

          if(isNaN(NumeroRighe) || Math.sign(NumeroRighe) == VALORE_FUNZIONE_SIGN_PER_NUMERO_NEGATIVO)
            return NUMERO_DEFAULT_RIGHE;

          return NumeroRighe;
        }
      },
      AltezzaTabella:
      {
        get()
        {
          return this.AltezzaTabella
        }
      },
    },
    mounted()
    {
      this.Paginazione.NrRighe = this.ComputedNumeroRighe;
    }
}
</script>